export const EcomWrapperEventListenerEnumsObj = {
    PAYAIR_ECOM_WRAPPER_SDK_LISTENER: "PAYAIR_ECOM_WRAPPER_SDK_LISTENER",
};
